import { render } from "./App.vue?vue&type=template&id=37efc7d8"
const script = {}

import "./App.vue?vue&type=style&index=0&id=37efc7d8&lang=css"
script.render = render

export default script